import React, { useEffect, useState } from "react";
// import { authFetch } from "../DecryptData"; // adjust path if needed
import { customEncode, authFetch } from "../DecryptData"; // adjust path if needed

function MarathiWordsPage() {
  const [fullWords, setFullWords] = useState([]);  // Full dataset (1M+)
  const [words, setWords] = useState([]);          // Filtered dataset
  const [loading, setLoading] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false); // ⭐ Filter popup


  const [filters, setFilters] = useState({
    id: "",
    english: "",
    marathi: "",
    counts: "",
    religion: "",
    caste: "",
    correctedenglish: "",
    correcteddictenglish: "",
  });

  const handleRowChange = (index, field, value) => {
    setWords(prev => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };


  useEffect(() => {
    fetchMarathiWords();
  }, []);

  const fetchMarathiWords = async () => {
    try {
      setLoading(true);

      const response = await authFetch(
        "http://anuplights.in:8083/apisecure/GetAllmarathiwords",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        }
      );

      const data = await response.json();

      if (Array.isArray(data)) {
        setFullWords(data);
        setWords(data);
      } else {
        setFullWords([]);
        setWords([]);
      }
    } catch (error) {
      console.error("Error fetching Marathi words:", error);
    } finally {
      setLoading(false);
    }
  };

  // ⭐ FILTER FUNCTION WITH POPUP LOADING
  const applyFilters = async (newFilters) => {
    // show popup immediately
    setFilterLoading(true);

    // update filter state
    setFilters(newFilters);

    // small debounce to avoid blocking UI on every keystroke
    // (you can adjust 200ms to taste)
    clearTimeout(applyFilters._timer);
    applyFilters._timer = setTimeout(() => {
      const filtered = fullWords.filter((item) => {
        const id = (item.MarathiWordId ?? "").toString();
        const english = (item.EnglishWords ?? "").toLowerCase();
        const marathi = (item.MarathiWords ?? "").toLowerCase();
        const counts = (item.Counts ?? "").toString();
        const religion = (item.religion ?? "").toLowerCase();
        const caste = (item.caste ?? "").toLowerCase();
        const correctedenglish = (item.correctedenglish ?? "").toLowerCase();
        const correcteddictenglish = (item.correcteddictenglish ?? "").toLowerCase();

        return (
          id.includes((newFilters.id || "").toLowerCase()) &&
          english.includes((newFilters.english || "").toLowerCase()) &&
          marathi.includes((newFilters.marathi || "").toLowerCase()) &&
          counts.includes((newFilters.counts || "").toLowerCase()) &&
          religion.includes((newFilters.religion || "").toLowerCase()) &&
          caste.includes((newFilters.caste || "").toLowerCase()) &&
          correctedenglish.includes((newFilters.correctedenglish || "").toLowerCase()) &&
          correcteddictenglish.includes((newFilters.correcteddictenglish || "").toLowerCase())
        );
      });

      setWords(filtered);
      setFilterLoading(false); // hide popup
    }, 200);
  };


  // ⭐ SHOW ONLY 100 ROWS WHEN NO FILTERS
  const isFiltering =
    filters.id ||
    filters.english ||
    filters.marathi ||
    filters.counts ||
    filters.religion ||
    filters.caste ||
    filters.correctedenglish ||
    filters.correcteddictenglish;

  const visibleWords = isFiltering ? words : words.slice(0, 100);

  // ⭐ SAVE ROW FUNCTION (Connect with API later)
  const handleSave = async (item) => {
    console.log("Saving row:", item);
    try {
      const res = await authFetch("http://anuplights.in:8083/apisecure/UpdateMarathiWord", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify(item),
        body: JSON.stringify({ data: customEncode(JSON.stringify(item)) }),
      });
      const data = await res.json();
      // optionally show success / failure
      console.log("Save response:", data);
    } catch (err) {
      console.error("Save failed:", err);
    }
  };


  return (
    <div style={{ padding: "20px" }}>
      <h2>Marathi Words List</h2>
      <hr />

      {/* Main Loading */}
      {loading && <h4>Loading...</h4>}

      {/* ⭐ Filter Loading Popup */}
      {filterLoading && (
        <div style={popupOverlay}>
          <div style={popupBox}>
            <h3>Filtering...</h3>
          </div>
        </div>
      )}

      {!loading && (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
          }}
        >
          <thead>
            <tr style={{ background: "#333", color: "white" }}>
              <th style={th}>ID</th>
              <th style={th}>English</th>
              <th style={th}>Marathi</th>
              <th style={th}>Counts</th>
              <th style={th}>Religion</th>
              <th style={th}>Caste</th>
              <th style={th}>Corrected Eng</th>
              <th style={th}>Dict Eng</th>
              <th style={th}>Actions</th>
            </tr>

            {/* FILTER INPUT ROW */}
            <tr style={{ background: "#ddd" }}>
              {Object.keys(filters).map((key) => (
                <th style={th} key={key}>
                  <input
                    style={input}
                    placeholder={`Search ${key}`}
                    value={filters[key]}
                    onChange={(e) =>
                      applyFilters({ ...filters, [key]: e.target.value })
                    }
                  />
                </th>
              ))}
              <th style={th}></th>
            </tr>
          </thead>

          <tbody>
            {visibleWords.map((item, i) => (
              <tr key={item.MarathiWordId ?? i} style={tr}>
                <td style={td}>
                  <input
                    style={rowInput}
                    value={item.MarathiWordId}
                    readOnly
                  />
                </td>

                <td style={td}>
                  <input
                    style={rowInput}
                    value={item.EnglishWords}
                    onChange={(e) => handleRowChange(i, "EnglishWords", e.target.value)}
                  />
                </td>

                <td style={td}>
                  <input
                    style={rowInput}
                    value={item.MarathiWords || ""}
                    onChange={(e) => handleRowChange(i, "MarathiWords", e.target.value)}
                  />
                </td>

                <td style={td}>
                  <input
                    style={rowInput}
                    value={item.Counts ?? ""}
                    onChange={(e) => handleRowChange(i, "Counts", e.target.value)}
                  />
                </td>

                <td style={td}>
                  <input
                    style={rowInput}
                    value={item.religion || ""}
                    onChange={(e) => handleRowChange(i, "religion", e.target.value)}
                  />
                </td>

                <td style={td}>
                  <input
                    style={rowInput}
                    value={item.caste || ""}
                    onChange={(e) => handleRowChange(i, "caste", e.target.value)}
                  />
                </td>

                <td style={td}>
                  <input
                    style={rowInput}
                    value={item.correctedenglish || ""}
                    onChange={(e) => handleRowChange(i, "correctedenglish", e.target.value)}
                  />
                </td>

                <td style={td}>
                  <input
                    style={rowInput}
                    value={item.correcteddictenglish || ""}
                    onChange={(e) => handleRowChange(i, "correcteddictenglish", e.target.value)}
                  />
                </td>


                <td style={td}>
                  <button style={saveBtn} onClick={() => handleSave(words[i])}>

                    Save
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const th = {
  border: "1px solid #ccc",
  padding: "10px",
  textAlign: "left",
};

const td = {
  border: "1px solid #ccc",
  padding: "5px",
};

const tr = {
  background: "white",
};

const input = {
  width: "100%",
  padding: "5px",
};

const rowInput = {
  width: "100%",
  padding: "5px",
  border: "1px solid #aaa",
};

const saveBtn = {
  padding: "8px",
  background: "green",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

/* ⭐ POPUP STYLES */
const popupOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const popupBox = {
  background: "white",
  padding: "30px",
  borderRadius: "10px",
  fontSize: "20px",
  fontWeight: "bold",
};

export default MarathiWordsPage;
